//@flow
import * as React from 'react'
import classnames from 'classnames'

import { Flex } from '..'
import FileManager from './FileManager'
import { useFilenameStyles } from './styles'

type FilenameProps = {
  type?: string,
  isAscendSelector?: boolean,
  isDirectory?: boolean,
  isClickable?: boolean,
  children?: React.Node
}

const Filename = ({ children, type, isDirectory, isAscendSelector, isClickable = true, ...props }: FilenameProps) => {
  const classes = useFilenameStyles()

  return (
    <Flex alignCenter className={classnames(classes.filenameWrapper, { clickable: isClickable })} {...props}>
      {isAscendSelector ? (
        <span className="filename ascend-selector">...</span>
      ) : (
        <>
          <i className="icon icon-s">{isDirectory ? 'folder' : FileManager.getFileIcon(type || '')}</i>
          <span className="filename">{children}</span>
        </>
      )}
    </Flex>
  )
}

export default Filename
